export default __webpack_public_path__ + "static/media/cog-solid.5b59ef93.svg";